/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { computed } from 'mobx';
import { DependencyList, useMemo } from 'react';

/**
 * A thin wrapper around the mobx computed implementation
 * instead of the "buggy" `useComputed` that is provided
 * by mobx-react.
 *
 * @param fn The factory function passed to the computed.
 * @param deps The dependencies of the computed function.
 * @returns A function that recomputes if any of the
 * dependencies change.
 */
export const useComputed = <T>(fn: () => T, deps: DependencyList) => useMemo(() => computed(fn), deps).get();
